import {
  faPlug,
  faSun,
  faCloudSun,
  faCloud,
  faCloudShowersHeavy,
  faCloudSunRain,
  faBolt,
  faSnowflake,
  faSmog,
  faMoon,
  faCloudMoon,
  faCloudMoonRain,
  faChevronUp,
  faChevronDown,
  faArrowUp,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faMinus
} from '@fortawesome/free-solid-svg-icons';

export default function getFontAwesomeIcons() {
  const icons = [
    faPlug,
    faSun,
    faCloudSun,
    faCloud,
    faCloudShowersHeavy,
    faCloudSunRain,
    faBolt,
    faSnowflake,
    faSmog,
    faMoon,
    faCloudMoon,
    faCloudMoonRain,
    faChevronUp,
    faChevronDown,
    faArrowUp,
    faArrowDown,
    faArrowLeft,
    faArrowRight,
    faMinus
  ];

  return icons;
}
